(() => {
  const root = document.documentElement;
  const boundaries = { start:1793426400000, special:1794376800000, last:1795672800000, end:1796104800000 };
  const phaseAt = now => now >= boundaries.end ? 'ended' : now >= boundaries.last ? 'last' : now >= boundaries.special ? 'special' : now >= boundaries.start ? 'packs' : 'pre';
  const resolvePhase = (scheduled, landing) => {
    if (landing.startsWith('packs-noviembre')) return scheduled === 'special' ? 'packs' : scheduled;
    if (landing === 'especial-buenfin') return ['pre','packs'].includes(scheduled) ? 'upcoming' : ['last','ended'].includes(scheduled) ? 'expired' : scheduled;
    return scheduled;
  };
  const homeView = scheduled => scheduled === 'special' ? 'especial-buenfin' : ['packs','last'].includes(scheduled) ? 'packs-noviembre' : null;
  const phase = () => root.dataset.campaignPreview || resolvePhase(phaseAt(Date.now()),root.dataset.campaignLanding || '');
  window.SigSagCampaign = { phase, phaseAt, resolvePhase, homeView, boundaries };
  const routeHome = scheduled => {
    const view = root.dataset.campaignHome === 'true' && (homeView(scheduled) || (root.dataset.campaignDraft === 'true' ? 'packs-noviembre' : null));
    if (!view) return false;
    const url = new URL(location.href);
    url.searchParams.set('view',view);
    location.replace(url.href);
    return true;
  };
  const update = () => {
    const scheduled = phaseAt(Date.now());
    if (routeHome(scheduled)) return;
    const next = phase();
    if (root.dataset.campaignPhase !== next) {
      root.dataset.campaignPhase = next;
      document.dispatchEvent(new CustomEvent('sigsag:campaign-change', {detail:next}));
    }
    document.querySelectorAll('[data-campaign-countdown]').forEach(el => {
      const now = Date.now(), finish = next === 'special' ? boundaries.last : boundaries.end;
      const active = ['packs','special','last'].includes(next) && now >= (next === 'special' ? boundaries.special : boundaries.start) && now < finish;
      el.hidden = !active;
      if (!active) return;
      const seconds = Math.max(0,Math.floor((finish-now)/1000));
      const pad = n => String(n).padStart(2,'0');
      el.textContent = `${Math.floor(seconds/86400)}d ${pad(Math.floor(seconds%86400/3600))}h ${pad(Math.floor(seconds%3600/60))}m`;
    });
  };
  update();
  document.addEventListener('DOMContentLoaded',update,{once:true});
  document.addEventListener('visibilitychange',update);
  setInterval(update,60000);
})();

